var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { Endcap } from '@thd-olt-component-react/endcap';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { useStore, ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { getPersonalizedDealsUserId } from '../../../../utils/personalizedDealsUtils';
export var TopSavingsForYou = function () {
    var _a;
    // must be a string
    var storeId = useStore().storeId;
    var _b = useContext(ExperienceContext), customer = _b.customer, channel = _b.channel;
    var defaultVariables = useContext(QueryContext).defaultVariables;
    var customerType = ((_a = customer === null || customer === void 0 ? void 0 : customer.type) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || 'B2B';
    var isB2BCustomer = customerType === 'B2B';
    // Hydrate does not currently work with Endcap, so removing for now
    return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    React.createElement("div", { className: "sui-ml-[-1.6rem] sui-mr-[-1.6rem]" },
        React.createElement(ErrorBoundary, { name: "endcap" },
            React.createElement(QueryProvider, { cacheKey: "endcap", defaultVariables: __assign(__assign({}, defaultVariables), { isBrandPricingPolicyCompliant: true }) },
                React.createElement(Endcap, { channel: channel === null || channel === void 0 ? void 0 : channel.toUpperCase(), customerType: customerType, pageUrl: "/", storeId: storeId, personalizedDealsUserid: getPersonalizedDealsUserId(isB2BCustomer, customerType), showLoading: true, isUppercase: false, headerWeight: "bold", runQueryServerSide: false })))));
};
